module.exports = {
  API_URL: 'API_URL_PLACEHOLDER',

  apiUrl: function() {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost') {
      return 'https://app.staging.cliento.com';
    }
    return !this.API_URL.includes('PLACEHOLDER')
      ? this.API_URL
      : origin;
  }
};
